import { Component, OnInit } from '@angular/core';
import { RegulatoryStatusEnum, RPCTrackStatusFilterItemsResponse, RpcTrackStatusSearchRequest } from '../../../remote-price-change/remote-price-change-service/remote-price-change.model';
import { FilterBarService } from '../../filter-bar-service/filter-bar.service';
import { ISubscription } from 'rxjs-compat/Subscription';

@Component({
  selector: 'app-rpc-status-filters',
  templateUrl: './rpc-status-filters.component.html',
  styleUrls: ['./rpc-status-filters.component.scss']
})
export class RpcStatusFiltersComponent implements OnInit {
  updatedMachineModelsDropdown: string[];
  vendorCodesDropdown: string[];
  upgradeStepsDropdown: string[];
  upgradeNotNeededReasonsDropdown: string[];
  dropdownItemSubscription: ISubscription;

  deviceNumber: string = '';
  machineNumber: string = '';
  regulatoryStatus: string = 'All';

  public filterItem: RpcTrackStatusSearchRequest;

  constructor(private _filter: FilterBarService) { }

  ngOnInit() {
    this.updatedMachineModelsDropdown = new Array();
    this.vendorCodesDropdown = new Array();
    this.upgradeStepsDropdown = new Array();
    this.upgradeNotNeededReasonsDropdown = new Array();
    this.filterItem = new RpcTrackStatusSearchRequest();

    this.dropdownItemSubscription = this._filter.GetRPCTrackStatusFilterData().subscribe((data: RPCTrackStatusFilterItemsResponse) => {
      this.fillDropdowns(data);
    });

    this._filter.resetFilters.subscribe(data => {
      this.performReset();
    });

    this._filter.rpcStatusFilters.subscribe((request: RpcTrackStatusSearchRequest) => {
      if (request) {
        this.applyExternalFilterState(request);
      }
    });
  }

  private fillDropdowns(data: RPCTrackStatusFilterItemsResponse) {
    data.updatedMachineModels.forEach(x => {
      this.updatedMachineModelsDropdown.push(x.name);
    });

    data.vendors.forEach(y => {
      this.vendorCodesDropdown.push(y.vendorCode);
    });

    data.upgradeSteps.forEach(z => {
      this.upgradeStepsDropdown.push(z.description);
    });

    if (data.upgradeNotNeededReasons) {
      this._filter.upgradeNotNeededReasons.next(data.upgradeNotNeededReasons);
      data.upgradeNotNeededReasons.forEach(r => {
        this.upgradeNotNeededReasonsDropdown.push(r.description);
      });
    }
  }

  changeUpdatedMachineModel(selection) {
    this.filterItem.updatedMachineModel = selection === "" ? null : selection;
    this._filter.updateRpcStatusFilter(this.filterItem);
  }

  changeVendorCode(selection) {
    this.filterItem.vendorCode = selection === "" ? null : selection;
    this._filter.updateRpcStatusFilter(this.filterItem);
  }

  changeUpgradeSteps(selection) {
    this.filterItem.upgradeSteps = selection === "" ? null : selection;
    this._filter.updateRpcStatusFilter(this.filterItem);
  }

  changeDeviceNumber(value: string) {
    this.filterItem.deviceNo = value;
    this._filter.updateRpcStatusFilter(this.filterItem);
  }

  changeMachineNumber(value: string) {
    this.filterItem.machineNumber = value ? Number(value) : null;
    this._filter.updateRpcStatusFilter(this.filterItem);
  }

  changeRegulatoryStatus(selection: string) {
    switch (selection) {
      case 'Regulatory':
        this.filterItem.regulatoryStatus = RegulatoryStatusEnum.Regulatory;
        break;
      case 'Non-Regulatory':
        this.filterItem.regulatoryStatus = RegulatoryStatusEnum.NonRegulatory;
        break;
      case 'Not on a Location':
        this.filterItem.regulatoryStatus = RegulatoryStatusEnum.NotOnALocation;
        break;
      default:
        this.filterItem.regulatoryStatus = RegulatoryStatusEnum.All;
        break;
    }
    this._filter.updateRpcStatusFilter(this.filterItem);
  }

  changeUpgradeNotNeededReason(selection) {
    this.filterItem.upgradeNotNeededReason = selection === "" ? null : selection;
    this._filter.updateRpcStatusFilter(this.filterItem);
  }

  changeUpgradeNeededCheckbox() {
    this.filterItem.upgradeNeeded = new Array();
    var yesCheckbox = <HTMLInputElement> document.getElementById("upgradeNeeded_yes");
    if (yesCheckbox.checked) {
      this.filterItem.upgradeNeeded.push('Yes');
    }
    var noCheckbox = <HTMLInputElement> document.getElementById("upgradeNeeded_no");
    if (noCheckbox.checked) {
      this.filterItem.upgradeNeeded.push('No');
    }
    this._filter.updateRpcStatusFilter(this.filterItem);
  }

  changeUpgradeCompleteCheckbox() {
    this.filterItem.upgradeComplete = new Array();
    var yesCheckbox = <HTMLInputElement> document.getElementById("upgradeComplete_yes");
    if (yesCheckbox.checked) {
      this.filterItem.upgradeComplete.push('Yes');
    }
    var noCheckbox = <HTMLInputElement> document.getElementById("upgradeComplete_no");
    if (noCheckbox.checked) {
      this.filterItem.upgradeComplete.push('No');
    }
    var naCheckbox = <HTMLInputElement> document.getElementById("upgradeComplete_na");
    if (naCheckbox.checked) {
      this.filterItem.upgradeComplete.push('N/A');
    }
    this._filter.updateRpcStatusFilter(this.filterItem);
  }

  changeTestingStatusCheckbox() {
    this.filterItem.testingStatus = new Array();
    var passCheckbox = <HTMLInputElement> document.getElementById("testingStatus_pass");
    if (passCheckbox.checked) {
      this.filterItem.testingStatus.push('Pass');
    }
    var failCheckbox = <HTMLInputElement> document.getElementById("testingStatus_fail");
    if (failCheckbox.checked) {
      this.filterItem.testingStatus.push('Fail');
    }
    var inProcessCheckbox = <HTMLInputElement> document.getElementById("testingStatus_inProcess");
    if (inProcessCheckbox.checked) {
      this.filterItem.testingStatus.push('In_Process');
    }
    var naCheckbox = <HTMLInputElement> document.getElementById("testingStatus_na");
    if (naCheckbox.checked) {
      this.filterItem.testingStatus.push('N/A');
    }
    this._filter.updateRpcStatusFilter(this.filterItem);
  }

  changeTestingCompleteCheckbox() {
    this.filterItem.testingComplete = new Array();
    var yesCheckbox = <HTMLInputElement> document.getElementById("testingComplete_yes");
    if (yesCheckbox.checked) {
      this.filterItem.testingComplete.push('Yes');
    }
    var noCheckbox = <HTMLInputElement> document.getElementById("testingComplete_no");
    if (noCheckbox.checked) {
      this.filterItem.testingComplete.push('No');
    }
    this._filter.updateRpcStatusFilter(this.filterItem);
  }

  showUpdatedMachineModelError() {

  }

  showVendorCodeError() {

  }

  showUpgradeStepsError() {

  }

  performReset() {
    const umdropdown = document.getElementById("updatedModelDropdown") as HTMLSelectElement;
    if (umdropdown){
      umdropdown.selectedIndex = 0;
    }
    this.filterItem.updatedMachineModel = null;
    const vcdropdown = document.getElementById("vendorCodeDropdown") as HTMLSelectElement;
    if (vcdropdown){
      vcdropdown.selectedIndex = 0;
    }
    this.filterItem.vendorCode = null;
    const usdropdown = document.getElementById("upgradeStepsDropdown") as HTMLSelectElement;
    if (usdropdown){
      usdropdown.selectedIndex = 0;
    }
    this.filterItem.upgradeSteps = null;
    const unnrdropdown = document.getElementById("upgradeNotNeededReasonDropdown") as HTMLSelectElement;
    if (unnrdropdown){
      unnrdropdown.selectedIndex = 0;
    }
    this.filterItem.upgradeNotNeededReason = null;

    // Reset Device Number
    const deviceNumberInput = document.getElementById("deviceNumberInput") as HTMLInputElement;
    if (deviceNumberInput) {
      deviceNumberInput.value = '';
    }
    this.deviceNumber = '';
    this.filterItem.deviceNo = null;

    // Reset Machine Number
    const machineNumberInput = document.getElementById("machineNumberInput") as HTMLInputElement;
    if (machineNumberInput) {
      machineNumberInput.value = '';
    }
    this.machineNumber = '';
    this.filterItem.machineNumber = null;

    // Reset Regulatory Status
    const regulatoryStatusDropdown = document.getElementById("regulatoryStatusDropdown") as HTMLSelectElement;
    if (regulatoryStatusDropdown) {
      regulatoryStatusDropdown.selectedIndex = 0;
    }
    this.regulatoryStatus = 'All';
    this.filterItem.regulatoryStatus = null;

    const unYesCheckbox = <HTMLInputElement> document.getElementById("upgradeNeeded_yes");
    unYesCheckbox.checked = false;
    const unNoCheckbox = <HTMLInputElement> document.getElementById("upgradeNeeded_no");
    unNoCheckbox.checked = false;
    const ucYesCheckbox = <HTMLInputElement> document.getElementById("upgradeComplete_yes");
    ucYesCheckbox.checked = false;
    const ucNoCheckbox = <HTMLInputElement> document.getElementById("upgradeComplete_no");
    ucNoCheckbox.checked = false;
    const ucNaCheckbox = <HTMLInputElement> document.getElementById("upgradeComplete_na");
    ucNaCheckbox.checked = false;
    const tsPassCheckbox = <HTMLInputElement> document.getElementById("testingStatus_pass");
    tsPassCheckbox.checked = false;
    const tsFailCheckbox = <HTMLInputElement> document.getElementById("testingStatus_fail");
    tsFailCheckbox.checked = false;
    const tsInProcessCheckbox = <HTMLInputElement> document.getElementById("testingStatus_inProcess");
    tsInProcessCheckbox.checked = false;
    const tsNaCheckbox = <HTMLInputElement> document.getElementById("testingStatus_na");
    tsNaCheckbox.checked = false;
    const tcYesCheckbox = <HTMLInputElement> document.getElementById("testingComplete_yes");
    tcYesCheckbox.checked = false;
    const tcNoCheckbox = <HTMLInputElement> document.getElementById("testingComplete_no");
    tcNoCheckbox.checked = false;
    this.filterItem.upgradeNeeded = new Array();
    this.filterItem.upgradeComplete = new Array();
    this.filterItem.testingStatus = new Array();
    this.filterItem.testingComplete = new Array();
  }

  private applyExternalFilterState(request: RpcTrackStatusSearchRequest) {
    // Reset all UI controls first
    this.performReset();

    // Set regulatory status dropdown
    const regulatoryStatusDropdown = document.getElementById("regulatoryStatusDropdown") as HTMLSelectElement;
    if (regulatoryStatusDropdown) {
      switch (request.regulatoryStatus) {
        case RegulatoryStatusEnum.Regulatory:
          regulatoryStatusDropdown.value = 'Regulatory';
          this.regulatoryStatus = 'Regulatory';
          break;
        case RegulatoryStatusEnum.NonRegulatory:
          regulatoryStatusDropdown.value = 'Non-Regulatory';
          this.regulatoryStatus = 'Non-Regulatory';
          break;
        case RegulatoryStatusEnum.NotOnALocation:
          regulatoryStatusDropdown.value = 'Not on a Location';
          this.regulatoryStatus = 'Not on a Location';
          break;
        default:
          regulatoryStatusDropdown.value = 'All';
          this.regulatoryStatus = 'All';
          break;
      }
    }
    this.filterItem.regulatoryStatus = request.regulatoryStatus;

    // Set upgrade needed checkboxes based on upgradeNeededLookupIDs
    if (request.upgradeNeededLookupIDs && request.upgradeNeededLookupIDs.length > 0) {
      const unYesCheckbox = <HTMLInputElement>document.getElementById("upgradeNeeded_yes");
      const unNoCheckbox = <HTMLInputElement>document.getElementById("upgradeNeeded_no");
      // LookupID 1 = No, LookupID 2 = Yes
      if (request.upgradeNeededLookupIDs.includes(2)) {
        unYesCheckbox.checked = true;
        this.filterItem.upgradeNeeded.push('Yes');
      }
      if (request.upgradeNeededLookupIDs.includes(1)) {
        unNoCheckbox.checked = true;
        this.filterItem.upgradeNeeded.push('No');
      }
    }
    this.filterItem.upgradeNeededLookupIDs = request.upgradeNeededLookupIDs || [];

    // Set upgrade complete checkboxes based on upgradeCompleteLookupIDs
    if (request.upgradeCompleteLookupIDs && request.upgradeCompleteLookupIDs.length > 0) {
      const ucYesCheckbox = <HTMLInputElement>document.getElementById("upgradeComplete_yes");
      const ucNoCheckbox = <HTMLInputElement>document.getElementById("upgradeComplete_no");
      const ucNaCheckbox = <HTMLInputElement>document.getElementById("upgradeComplete_na");
      // LookupID 1 = No, LookupID 2 = Yes, LookupID 3 = N/A
      if (request.upgradeCompleteLookupIDs.includes(2)) {
        ucYesCheckbox.checked = true;
        this.filterItem.upgradeComplete.push('Yes');
      }
      if (request.upgradeCompleteLookupIDs.includes(1)) {
        ucNoCheckbox.checked = true;
        this.filterItem.upgradeComplete.push('No');
      }
      if (request.upgradeCompleteLookupIDs.includes(3)) {
        ucNaCheckbox.checked = true;
        this.filterItem.upgradeComplete.push('N/A');
      }
    }
    this.filterItem.upgradeCompleteLookupIDs = request.upgradeCompleteLookupIDs || [];

    // Update the filter service so the main component picks up the state
    this._filter.updateRpcStatusFilter(this.filterItem);
  }

}
